import home from '@/language/zh_CN/home'
import industry from '@/language/zh_CN/industry'
import about from '@/language/zh_CN/about'
import jobs from '@/language/zh_CN/jobs'
import contact from '@/language/zh_CN/contact'
import cases from '@/language/zh_CN/cases'
import awards from '@/language/zh_CN/awards'
// 服務
import enterprise from '@/language/zh_CN/service/enterprise'
import businessProcess from '@/language/zh_CN/service/businessProcess'
import digital from '@/language/zh_CN/service/digital'
import enterpriseApplication from '@/language/zh_CN/service/enterpriseApplication'
import crm from '@/language/zh_CN/service/crm'

import blockchains from '@/language/zh_CN/service/blockchains'
import businessApplication from '@/language/zh_CN/service/businessApplication'
import dataAnalytics from '@/language/zh_CN/service/dataAnalytics'
import artificialIntelligence from '@/language/zh_CN/service/artificialIntelligence'
import aiVideoProduction from '@/language/zh_CN/service/aiVideoProduction'

import softwareDevelopment from '@/language/zh_CN/service/softwareDevelopment'
import enterpriseMobility from '@/language/zh_CN/service/enterpriseMobility'
import cloud from '@/language/zh_CN/service/cloud'
import intelligentManufacturing from '@/language/zh_CN/service/intelligentManufacturing'
import networkSecurity from '@/language/zh_CN/service/networkSecurity'
import globalization from '@/language/zh_CN/service/globalization'
import bigData from '@/language/zh_CN/service/bigData'
import internetThings from '@/language/zh_CN/service/internetThings'

import applicationOutsourcing from '@/language/zh_CN/service/applicationOutsourcing'
import businessProcessOutsourcing from '@/language/zh_CN/service/businessProcessOutsourcing'
import customerService from '@/language/zh_CN/service/customerService'
import humanResource from '@/language/zh_CN/service/humanResource'
import gamingField from '@/language/zh_CN/service/gamingField'
export default {
  home,
  industry,
  about,
  jobs,
  contact,
  cases,
  awards,
  // 服務
  enterprise,
  businessProcess,
  digital,
  enterpriseApplication,
  crm,
  blockchains,
  businessApplication,
  dataAnalytics,
  artificialIntelligence,
  aiVideoProduction,
  softwareDevelopment,
  enterpriseMobility,
  cloud,
  intelligentManufacturing,
  networkSecurity,
  globalization,
  bigData,
  internetThings,
  applicationOutsourcing,
  businessProcessOutsourcing,
  customerService,
  humanResource,
  gamingField
}
